import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-100 text-gray-800 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <img 
              src="https://public.readdy.ai/ai/img_res/f4623e0a-312d-401f-b9c1-68865bd89bf6.png" 
              alt="P'tit Voyou" 
              className="h-14 w-14 md:h-16 md:w-16 object-contain mb-3"
            />
            <p className="text-sm text-gray-500">
              {t('footer.brandText')}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-xs md:text-sm font-bold mb-3 md:mb-4 tracking-wide text-brand-pink">{t('footer.navigation')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-xs md:text-sm text-gray-500 hover:text-brand-pink transition-colors cursor-pointer">
                  {t('footer.home')}
                </Link>
              </li>
              <li>
                <Link to="/boutique" className="text-xs md:text-sm text-gray-500 hover:text-brand-pink transition-colors cursor-pointer">
                  {t('footer.shop')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-xs md:text-sm text-gray-500 hover:text-brand-pink transition-colors cursor-pointer">
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Informations */}
          <div>
            <h3 className="text-xs md:text-sm font-bold mb-3 md:mb-4 tracking-wide text-brand-pink">{t('footer.information')}</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-xs md:text-sm text-gray-500 hover:text-brand-pink transition-colors cursor-pointer">
                  {t('footer.delivery')}
                </a>
              </li>
              <li>
                <a href="#" className="text-xs md:text-sm text-gray-500 hover:text-brand-pink transition-colors cursor-pointer">
                  {t('footer.terms')}
                </a>
              </li>
              <li>
                <a href="#" className="text-xs md:text-sm text-gray-500 hover:text-brand-pink transition-colors cursor-pointer">
                  {t('footer.privacy')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="text-xs md:text-sm font-bold mb-3 md:mb-4 tracking-wide text-brand-pink">{t('footer.followUs')}</h3>
            <div className="flex space-x-3 mb-3">
              <a href="https://www.instagram.com/ptitvoyoureveur?igsh=NG5mMzF4N2JxY2xm&utm_source=qr" target="_blank" rel="nofollow noreferrer" className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-brand-pink text-white rounded-full hover:bg-brand-pink-dark transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg md:text-xl"></i>
              </a>
            </div>
            <p className="text-xs md:text-sm text-gray-500">
              <i className="ri-phone-line mr-1"></i>
              +216 96 686 682
            </p>
          </div>
        </div>

        <div className="border-t border-gray-300 mt-6 md:mt-8 pt-6 md:pt-8 text-center text-xs md:text-sm text-gray-400">
          <p>&copy; 2025 P'tit Voyou. {t('footer.rights')}.</p>
        </div>
      </div>
    </footer>
  );
}
